import React, {useEffect, useRef, useState} from 'react';
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

/**
 * @description      This is TextField
 * @return JSX.Element
 * @author          Kerem Karadeniz
 * @param value,
 * @param onChange
 * @param autoComplete
 * @param width
 * @param height
 * @param color
 * @param fontWeight
 * @param fontSize
 * @param padding
 * @param background
 * @param borderRadius
 * @param border
 * @param multiline
 * @param rows
 * @param cols
 * @param resize
 * @param overFlowY
 * @param validate
 * @param name
 */
const TextField = ({
                            value = "",
                            onChange,
                            autoComplete = "off",
                            width,
                            height,
                            color,
                            fontWeight,
                            fontSize,
                            padding,
                            background,
                            borderRadius,
                            border,
                            multiline = false,
                            rows = 2,
                            cols = 40,
                            resize = "none",
                            overFlowY = "hidden",
                            required = false,
                            name = ""
                        }) => {

    const [style, setStyle] = useState({});
    const textareaRef = useRef(null);
    const {t} = useTranslation();
    useEffect(() => {
        setStyle({
            width: width ? width : "90%",
            minHeight: height ? height : 34,
            color: color ? color : "#8F94A6",
            fontWeight: fontWeight ? fontWeight : "600",
            fontSize: fontSize ? fontSize : 12,
            padding: padding ? padding : "8px",
            outline: 0,
            boxSizing: "border-box",
            border: border ? border : "1px solid #E6E6E6",
            borderRadius: borderRadius ? borderRadius : 2,
            background: background ? background : "#FCFCF",

        })
    }, [])

   // text area set is auto size
    useEffect(() => {
        if(textareaRef?.current?.style){
            textareaRef.current.style.height = "0px";
            const scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = scrollHeight + "px";
        }
    }, [value]);


    return (<div>
        <form noValidate autoComplete={autoComplete}>
            {!multiline ? <input id="auTextInput"  name={name}  type="text" value={value} onChange={onChange} style={{...style}}/> :
                <textarea name={name} ref={textareaRef} id="auTextArea" rows={rows} cols={cols} value={value} onChange={onChange}
                          style={{...style, resize: resize, overflowY: overFlowY}}/>}
        </form>
        { required === true ? (
                value?.length === 0 &&   <small style={{color:"#D75E5E"}}>{t('MESSAGES.FIELD-REQUIRED')}</small>
        ) : null}
    </div>);
};

TextField.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    autoComplete: PropTypes.any,
    width: PropTypes.any,
    height: PropTypes.any,
    color: PropTypes.string,
    fontWeight: PropTypes.any,
    fontSize: PropTypes.any,
    padding: PropTypes.any,
    background: PropTypes.string,
    borderRadius: PropTypes.any,
    border: PropTypes.any,
    multiline: PropTypes.bool,
    rows: PropTypes.any,
    cols: PropTypes.any,
    resize: PropTypes.any,
    overFlowY: PropTypes.any,
    required: PropTypes.bool,
    name: PropTypes.string,
}

export default TextField;